module.exports = __webpack_public_path__ + "img/control_de_calidad3_4-3_682.d524146f.webp";